import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { IoAirplaneOutline, IoCalendarOutline, IoPeopleOutline, IoWalletOutline, IoPaperPlaneOutline, IoChevronDownOutline, IoSparkles } from 'react-icons/io5';
import './PlanMyTrip.css';

const PlanMyTrip = () => {
  const [formData, setFormData] = useState({ destination: '', date: '', people: '', budget: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Inquiry Sent Successfully!");
  };

  return (
    <div className="pmt-page-wrapper">
      {/* Background Decorative Circles */}
      <div className="pmt-bg-circle circle-1"></div>
      <div className="pmt-bg-circle circle-2"></div>

      <motion.div 
        className="pmt-main-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        {/* Header with Continuous Pulse Animation */}
        <motion.div 
          className="pmt-header-box"
          animate={{ y: [0, -8, 0] }}
          transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
        >
          <div className="pmt-exclusive-tag">
            <IoSparkles /> <span>Chandrama Holidays</span>
          </div>
          <h1>Craft Your <span>Personalized</span> Trip</h1>
          <div className="pmt-underline"></div>
        </motion.div>

        {/* Glassmorphic Form Card */}
        <motion.form 
          className="pmt-glass-card"
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: false, amount: 0.2 }} // Scroll karne par activate hoga
          transition={{ duration: 0.8, ease: "easeOut" }}
          onSubmit={handleSubmit}
        >
          <div className="pmt-form-grid">
            
            {/* Field 1 */}
            <div className="pmt-input-wrapper">
              <label><IoAirplaneOutline /> Where to?</label>
              <input type="text" placeholder="Dream Destination" required />
            </div>

            {/* Field 2 */}
            <div className="pmt-input-wrapper">
              <label><IoCalendarOutline /> When?</label>
              <input type="date" required />
            </div>

            {/* Field 3 */}
            <div className="pmt-input-wrapper">
              <label><IoPeopleOutline /> How many?</label>
              <input type="number" placeholder="No. of Persons" required />
            </div>

            {/* Field 4 - Dropdown */}
            <div className="pmt-input-wrapper">
              <label><IoWalletOutline /> Budget</label>
              <div className="pmt-select-box">
                <select required>
                  <option value="">Select Package</option>
                  <option value="economy">Economy</option>
                  <option value="premium">Premium</option>
                  <option value="luxury">Luxury Elite</option>
                </select>
                <IoChevronDownOutline className="pmt-drop-icon" />
              </div>
            </div>

            {/* Full Width Field */}
            <div className="pmt-input-wrapper pmt-full">
              <label>Tell us more about your vibe...</label>
              <textarea placeholder="Any special requests or preferences?" rows="3"></textarea>
            </div>
          </div>

          <motion.button 
            className="pmt-submit-btn"
            whileHover={{ scale: 1.03, boxShadow: "0 15px 30px rgba(247, 147, 30, 0.4)" }}
            whileTap={{ scale: 0.97 }}
          >
            Send My Inquiry <IoPaperPlaneOutline />
          </motion.button>
        </motion.form>
      </motion.div>
    </div>
  );
};

export default PlanMyTrip;